import React from 'react';
import BatchDetailedReport from './BatchDetailedReport';

/**
 * Running Batch Report (in-progress) — data-driven. Reuses the detailed report
 * component; completed operations show actual data and pending/running ones show
 * current state. (The RUNNING badge is driven by header.is_running from the API.)
 */
const RunningReport = ({ batchNumber }) => (
  <BatchDetailedReport batchNumber={batchNumber} />
);

export default RunningReport;
